// Backward-compat shim — file moved to ./inbox/SimpleMessageContext
export * from "./inbox/SimpleMessageContext";
